<template>
  <div id="stock-chart" @click="resizechart"></div>
</template>

<script>
import Highcharts from "highcharts/highstock";
import Exporting from "highcharts/modules/exporting";
import ExportData from "highcharts/modules/export-data";

Exporting(Highcharts);
ExportData(Highcharts);

export default {
  props: {
    dataA: Array,
    dataB: Array,
    dataC: Array,
  },
  data() {
    return {
      stockChart: null,
    };
  },
  mounted() {
    this.createChart(this.dataA, this.dataB, this.dataC);
  },
  methods: {
    createChart(dataA, dataB, dataC) {
      this.stockChart = Highcharts.stockChart("stock-chart", {
        chart: {
          backgroundColor: "transparent",
        },
        rangeSelector: {
          buttons: [
            {
              type: "hour",
              count: 3,
              text: "3h",
            },
            {
              type: "hour",
              count: 6,
              text: "6h",
            },
            {
              type: "hour",
              count: 12,
              text: "12h",
            },
            {
              type: "day",
              count: 1,
              text: "1D",
            },
            {
              type: "day",
              count: 7,
              text: "1W",
            },
            {
              type: "all",
              count: 1,
              text: "All",
            },
          ],
          selected: 1,
          inputEnabled: true,
        },

        title: {
          text: "Vibration Sensor Graph",
          align: "left",
          style: {
            color: "#808080",
            fontSize: "18px",
            "font-weight": "900",
          },
        },

        series: [
          {
            name: "X (mm/s)",
            data: dataA,
            tooltip: {
              valueDecimals: 2,
            },
          },
          {
            name: "Y (mm/s)",
            data: dataB,
            tooltip: {
              valueDecimals: 2,
            },
          },
          {
            name: "Z (mm/s)",
            data: dataC,
            tooltip: {
              valueDecimals: 2,
            },
          },
        ],
      });

      // resize chart
      const ro = new ResizeObserver((entries) => {
        this.stockChart.reflow();
      });
      ro.observe(document.getElementById("stock-chart"));
    },
  },
};
</script>

<style>
</style>